import { BaseEntity, GraphqlOperation } from '@funtech-int/kp-graphql-sdk/yango-movies-www';
import { createResourceQuery } from '@funtech-int/rival';
import { useResources } from '@funtech-int/rival-react';

import { GraphqlClient, GraphqlResponse } from '@/shared/lib/graphqlClient';

import { useGraphqlClient } from './useGraphqlClient';

interface GQLQueryParams {
    operation: GraphqlOperation<any, any, any, any>;
    variables: any;
    client: GraphqlClient;
}

const gqlResourceQuery = createResourceQuery<GQLQueryParams, any>({
    key(ctx) {
        return btoa(JSON.stringify([ctx.operation.name, ctx.variables]));
    },

    fetch(ctx) {
        return ctx.client.fetch({ operation: ctx.operation, variables: ctx.variables });
    },

    hydrate(data, ctx) {
        return { data: ctx.operation.hydrate(data) };
    },

    toJSON({ data }) {
        return data;
    },
});

export function useGqlQuery<Q, D, R extends BaseEntity<D> | null, V>(
    operation: GraphqlOperation<Q, D, R, V>,
    variables: V,
    options?: {
        lifetime?: number;
    }
): GraphqlResponse<R> {
    const client = useGraphqlClient();

    const [result] = useResources(
        gqlResourceQuery(
            {
                operation,
                variables,
                client,
            },
            options
        )
    );

    return result;
}
